import {
    SET_SEARCH_HISTORY,
} from './searchHistoryConstants';
import { setValue } from '../../lib/immutable_wrapper'

const initialState = {
    searchHistory: [],
};

export function searchHistory(state = initialState, action) {
    switch (action.type) {
        case SET_SEARCH_HISTORY:
            return setValue(state, ['searchHistory'], action.searchHistory);
        default:
            return state;
    }
}
